// HomePage.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import Carousel from "./carousel";
import Carousel2 from "./carousel2";
import Background from "./home_page_bg.png";
import ImageGrid from "./image_grid";
import { FaArrowUp } from "react-icons/fa";
import Cards from "./cards";
import { useDispatch, useSelector } from "react-redux";
import { fetchWelcomeData, fetchPopupImage } from "../../redux/slicer/homeSlicer";
import PopupBanner from "../../components/popupBanner";
import { Helmet } from "react-helmet-async";
import Preloader from "../../assets/sab.jpeg";

function HomePage() {
  const dispatch = useDispatch();
  const { welcome } = useSelector((state) => state.home);
  const { data: welcomeData, loading, error } = welcome;

  const [showPopup, setShowPopup] = useState(false);
  const [popupKey, setPopupKey] = useState(0); //Key to remount PopupBanner

  useEffect(() => {
    dispatch(fetchWelcomeData());
    dispatch(fetchPopupImage());

    // Delay before showing the popup
    const delayTimeout = setTimeout(() => {
      setShowPopup(true);
    }, 1000); // Adjust the delay (in milliseconds) as needed

    // Cleanup the timeout in case the component unmounts before the timeout completes
    return () => clearTimeout(delayTimeout);

  }, [dispatch]);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <img src={Preloader} alt="Loading..." className="w-24 h-24 sm:w-32 sm:h-32" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <p className="text-red-600 text-lg font-bold">Error: {error}</p>
      </div>
    );
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="space-y-10">
      {/* Carousel Section */}
      <div>
        <Carousel />
      </div>

      {/* Welcome Section */}
      <div className="space-y-4 text-center px-4">
        <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-primary-color mt-4  font-titillium">
          Welcome to SAB Campus of CA Sri Lanka
        </h1>
        <h2 className="text-lg sm:text-xl md:text-2xl font-inter font-semibold">
          {welcomeData?.welcome_message || "Welcome to our campus!"}
        </h2>
      </div>

      {/* Statistics Section */}
      <div className="py-6">
        <div className="relative w-full h-auto">
          {/* Background Image */}
          <img src={Background} alt="Background" className="w-full h-[250px] sm:h-[350px] object-cover" />

          {/* Cards */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full px-2 sm:px-4">
            <div className="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8 lg:gap-10 max-w-screen-lg mx-auto">
              {[
                {
                  label: "Graduates",
                  value: `${welcomeData?.graduates}+`,
                  textColor: "text-black",
                  bgColor: "bg-[#efbbff]"
                },
                {
                  label: "Faculty Members",
                  value: `${welcomeData?.faculty_members}+`,
                  textColor: "text-black",
                  bgColor: "bg-[#d896ff]",
                },
                {
                  label: "Employability Rate",
                  value: `${welcomeData?.employability_rate}%`,
                  textColor: "text-black",
                  bgColor: "bg-[#be29ec] ",
                },
                {
                  label: "Years of Excellence",
                  value: `${welcomeData?.years_of_excellence}+`,
                  textColor: "text-black",
                  bgColor: "bg-[#800080]",
                },
              ].map((item, index) => (
                <div key={index} className="transform transition hover:scale-105">
                  <Cards
                    title={item.label}
                    content={item.value}
                    bgColor={item.bgColor}
                    textColor={item.textColor}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Partners Section */}
      <div className="space-y-4 px-6 sm:px-16" id="patners">
        <p className="text-primary-color text-center"></p>
        <p className="text-2xl sm:text-4xl text-primary-color font-semibold text-center  font-titillium">
          Accreditations and Recognitions
        </p>
        <div className="mt-8">
          <Carousel2 />
        </div>
      </div>

      {/* Image Grid Section */}
      <div className="px-4 sm:px-28" id="gallery">
        <ImageGrid />
      </div>

      {showPopup && (
          <PopupBanner onClose={handleClosePopup} />
      )}

    </div>
  );
}

export default HomePage;